export default "__VITE_ASSET__Bss0VAS___"